import { Loader } from "../icons/Loader";
import classNames from "classnames";
import imgGivingBasket from "~/assets/images/icons/giving_basket.png";

export function DonateButton({
  enabled,
  loading,
  size = "lg",
  className,
  label,
  onClick,
}: {
  enabled: boolean;
  loading: boolean;
  size?: "md" | "lg" | "xl";
  className?: string;
  label?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  const textSize =
    size === "md" ? "tw:text-md" : size === "lg" ? "tw:text-lg" : "tw:text-xl";

  const donateTextImage = (
    <div className="tw:flex tw:flex-row tw:justify-center tw:items-center tw:w-full tw:p-2 tw:md:p-1">
      <div
        className={classNames(size === "md" ? "tw:px-1" : "tw:px-2", textSize)}
      >
        {label || "Donate"}
      </div>
      <img
        width={size === "md" ? "24" : "28"}
        height={size === "md" ? "23" : "27"}
        alt="giving basket"
        src={imgGivingBasket}
      />
    </div>
  );

  const donateLoading = (
    <div className="tw:flex tw:flex-row tw:justify-center tw:items-center tw:w-full tw:p-1">
      <div className={classNames("tw:px-2", textSize)}> Donate</div>
      <Loader />
    </div>
  );

  return (
    <div className={className}>
      {enabled ? (
        <button
          className={classNames(
            size === "md" ? "cn-wp-button-donate-md" : "cn-wp-button-donate",
            "tw:h-full",
          )}
          onClick={(e) => onClick?.(e)}
        >
          {loading ? donateLoading : donateTextImage}
        </button>
      ) : (
        <button
          className={classNames(
            size === "md"
              ? "cn-wp-button-donate-disabled-md"
              : "cn-wp-button-donate-disabled",
            "tw:h-full",
            "donate-link",
          )}
          disabled
        >
          {loading ? donateLoading : donateTextImage}
        </button>
      )}
    </div>
  );
}
